// extracted by mini-css-extract-plugin
module.exports = {"card":"playerStatsTable_card__Hf_cb","content":"playerStatsTable_content__x_wqQ","table":"playerStatsTable_table__fkMyX"};